import React from 'react';
import { Box, Typography } from '@mui/material';

const VOICE_TRANSCRIPT_SEPARATOR = /\s+Voice transcript:\s*/i;

export const splitCaptureBundleTimelineText = (value = '') => {
  const text = String(value || '').trim();
  const parts = text.split(VOICE_TRANSCRIPT_SEPARATOR);
  if (parts.length < 2) return null;

  const caregiverText = String(parts.shift() || '').trim();
  const voiceTranscript = parts.join('\n').trim();
  return caregiverText && voiceTranscript ? { caregiverText, voiceTranscript } : null;
};

const CaptureBundleSection = ({ label, children }) => (
  <Box sx={{ minWidth: 0 }}>
    <Typography sx={{ mb: 0.15, fontSize: '0.68rem', lineHeight: 1.2, fontWeight: 700, color: '#6B7280' }}>
      {label}
    </Typography>
    <Typography sx={{ fontSize: '0.9rem', lineHeight: 1.4, fontWeight: 400, color: '#1F2937', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
      {children}
    </Typography>
  </Box>
);

const CaptureBundleTimelineText = ({ sections }) => {
  if (!sections) return null;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.8 }}>
      <CaptureBundleSection label="Note">{sections.caregiverText}</CaptureBundleSection>
      <CaptureBundleSection label="Voice transcript">{sections.voiceTranscript}</CaptureBundleSection>
    </Box>
  );
};

export default React.memo(CaptureBundleTimelineText);
